module.exports = __webpack_public_path__ + "static/media/Administracion6.1d54b09.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion6.mp3
// module id = 713
// module chunks = 1